import { render } from "./shareAlbumNative.vue?vue&type=template&id=5e93a718&scoped=true"
import script from "./shareAlbumNative.vue?vue&type=script&lang=js"
export * from "./shareAlbumNative.vue?vue&type=script&lang=js"

import "./shareAlbumNative.vue?vue&type=style&index=0&id=5e93a718&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e93a718"]])

export default __exports__